import { addWeeks, subWeeks, formatISO } from 'date-fns';

// Données simulées pour les projets
export const mockProjets = [
  {
    id: 1,
    nom: 'Refonte Site E-commerce',
    description: 'Refonte complète du site de vente en ligne avec nouvelles fonctionnalités',
    date_debut: '2024-01-01',
    date_fin: '2024-03-31',
    budget_jours: 85.0,
    statut: 'en_cours',
    facturable: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 2,
    nom: 'Application Mobile CRM',
    description: 'Développement d\'une application mobile pour la gestion client',
    date_debut: '2024-02-01',
    date_fin: '2024-05-31',
    budget_jours: 72.0,
    statut: 'en_cours',
    facturable: true,
    created_at: '2024-02-01T00:00:00.000Z',
    updated_at: '2024-02-01T00:00:00.000Z'
  },
  {
    id: 3,
    nom: 'Système de Gestion Documentaire',
    description: 'Mise en place d\'un système de gestion documentaire interne',
    date_debut: '2024-03-01',
    date_fin: '2024-06-30',
    budget_jours: 55.0,
    statut: 'planifie',
    facturable: false,
    created_at: '2024-03-01T00:00:00.000Z',
    updated_at: '2024-03-01T00:00:00.000Z'
  },
  {
    id: 4,
    nom: 'Migration Cloud Infrastructure',
    description: 'Migration de l\'infrastructure vers le cloud AWS',
    date_debut: '2024-01-15',
    date_fin: '2024-04-15',
    budget_jours: 95.0,
    statut: 'en_cours',
    facturable: true,
    created_at: '2024-01-15T00:00:00.000Z',
    updated_at: '2024-01-15T00:00:00.000Z'
  },
  {
    id: 5,
    nom: 'Plateforme de Formation en Ligne',
    description: 'Développement d\'une plateforme de formation avec vidéos et quiz',
    date_debut: '2024-04-01',
    date_fin: '2024-08-31',
    budget_jours: 120.0,
    statut: 'planifie',
    facturable: true,
    created_at: '2024-04-01T00:00:00.000Z',
    updated_at: '2024-04-01T00:00:00.000Z'
  }
];

// Données simulées pour les personnes
export const mockPersonnes = [
  {
    id: 1,
    nom: 'Martin',
    prenom: 'Jean',
    email: 'jean.martin@example.com',
    role: 'chef_projet',
    taux_journalier: 650.00,
    indice_productivite: 85, // Pourcentage de productivité
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 2,
    nom: 'Dubois',
    prenom: 'Marie',
    email: 'marie.dubois@example.com',
    role: 'developpeur',
    taux_journalier: 550.00,
    indice_productivite: 90,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 3,
    nom: 'Bernard',
    prenom: 'Pierre',
    email: 'pierre.bernard@example.com',
    role: 'developpeur',
    taux_journalier: 520.00,
    indice_productivite: 80,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 4,
    nom: 'Moreau',
    prenom: 'Sophie',
    email: 'sophie.moreau@example.com',
    role: 'designer',
    taux_journalier: 480.00,
    indice_productivite: 95,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 5,
    nom: 'Petit',
    prenom: 'Thomas',
    email: 'thomas.petit@example.com',
    role: 'testeur',
    taux_journalier: 450.00,
    indice_productivite: 75,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 6,
    nom: 'Durand',
    prenom: 'Claire',
    email: 'claire.durand@example.com',
    role: 'analyste',
    taux_journalier: 500.00,
    indice_productivite: 88,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 7,
    nom: 'Leroy',
    prenom: 'Antoine',
    email: 'antoine.leroy@example.com',
    role: 'developpeur',
    taux_journalier: 530.00,
    indice_productivite: 85,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  },
  {
    id: 8,
    nom: 'Roux',
    prenom: 'Isabelle',
    email: 'isabelle.roux@example.com',
    role: 'testeur',
    taux_journalier: 460.00,
    indice_productivite: 82,
    actif: true,
    created_at: '2024-01-01T00:00:00.000Z',
    updated_at: '2024-01-01T00:00:00.000Z'
  }
];

// Données simulées pour les rattachements
export const mockRattachements = [
  // Projet 1: Refonte Site E-commerce
  { id: 1, id_projet: 1, id_personne: 1, role_projet: 'chef_projet', date_debut: '2024-01-01', date_fin: '2024-03-31', actif: true },
  { id: 2, id_projet: 1, id_personne: 2, role_projet: 'developpeur', date_debut: '2024-01-01', date_fin: '2024-03-31', actif: true },
  { id: 3, id_projet: 1, id_personne: 3, role_projet: 'developpeur', date_debut: '2024-01-15', date_fin: '2024-03-31', actif: true },
  { id: 4, id_projet: 1, id_personne: 4, role_projet: 'designer', date_debut: '2024-01-01', date_fin: '2024-02-15', actif: true },
  { id: 5, id_projet: 1, id_personne: 5, role_projet: 'testeur', date_debut: '2024-02-01', date_fin: '2024-03-31', actif: true },
  
  // Projet 2: Application Mobile CRM
  { id: 6, id_projet: 2, id_personne: 1, role_projet: 'chef_projet', date_debut: '2024-02-01', date_fin: '2024-05-31', actif: true },
  { id: 7, id_projet: 2, id_personne: 7, role_projet: 'developpeur', date_debut: '2024-02-01', date_fin: '2024-05-31', actif: true },
  { id: 8, id_projet: 2, id_personne: 6, role_projet: 'analyste', date_debut: '2024-02-01', date_fin: '2024-03-15', actif: true },
  { id: 9, id_projet: 2, id_personne: 8, role_projet: 'testeur', date_debut: '2024-03-01', date_fin: '2024-05-31', actif: true },
  
  // Projet 3: Système de Gestion Documentaire
  { id: 10, id_projet: 3, id_personne: 2, role_projet: 'developpeur', date_debut: '2024-03-01', date_fin: '2024-06-30', actif: true },
  { id: 11, id_projet: 3, id_personne: 6, role_projet: 'analyste', date_debut: '2024-03-01', date_fin: '2024-04-15', actif: true },
  
  // Projet 4: Migration Cloud Infrastructure
  { id: 12, id_projet: 4, id_personne: 3, role_projet: 'developpeur', date_debut: '2024-01-15', date_fin: '2024-04-15', actif: true },
  { id: 13, id_projet: 4, id_personne: 7, role_projet: 'developpeur', date_debut: '2024-01-15', date_fin: '2024-04-15', actif: true }
];

// Données simulées pour les temps planifiés
export const mockTempsPlanifies = [
  // Projet 1: Refonte Site E-commerce
  { id: 1, id_projet: 1, semaine: '2024-01-01', analyse_design: 2.0, build: 3.0, test: 0.0, total_planifie: 5.0 },
  { id: 2, id_projet: 1, semaine: '2024-01-08', analyse_design: 1.5, build: 4.0, test: 0.5, total_planifie: 6.0 },
  { id: 3, id_projet: 1, semaine: '2024-01-15', analyse_design: 1.0, build: 5.0, test: 1.0, total_planifie: 7.0 },
  { id: 4, id_projet: 1, semaine: '2024-01-22', analyse_design: 0.5, build: 5.0, test: 1.5, total_planifie: 7.0 },
  { id: 5, id_projet: 1, semaine: '2024-01-29', analyse_design: 0.5, build: 4.5, test: 2.0, total_planifie: 7.0 },
  { id: 6, id_projet: 1, semaine: '2024-02-05', analyse_design: 0.0, build: 4.0, test: 3.0, total_planifie: 7.0 },
  { id: 7, id_projet: 1, semaine: '2024-02-12', analyse_design: 0.0, build: 3.5, test: 3.5, total_planifie: 7.0 },
  { id: 8, id_projet: 1, semaine: '2024-02-19', analyse_design: 0.0, build: 3.0, test: 4.0, total_planifie: 7.0 },
  { id: 9, id_projet: 1, semaine: '2024-02-26', analyse_design: 0.0, build: 2.5, test: 4.5, total_planifie: 7.0 },
  { id: 10, id_projet: 1, semaine: '2024-03-04', analyse_design: 0.0, build: 2.0, test: 5.0, total_planifie: 7.0 },
  { id: 11, id_projet: 1, semaine: '2024-03-11', analyse_design: 0.0, build: 1.5, test: 3.5, total_planifie: 5.0 },
  { id: 12, id_projet: 1, semaine: '2024-03-18', analyse_design: 0.0, build: 1.0, test: 2.0, total_planifie: 3.0 },

  // Projet 2: Application Mobile CRM
  { id: 13, id_projet: 2, semaine: '2024-02-05', analyse_design: 3.0, build: 2.0, test: 0.0, total_planifie: 5.0 },
  { id: 14, id_projet: 2, semaine: '2024-02-12', analyse_design: 2.5, build: 3.0, test: 0.5, total_planifie: 6.0 },
  { id: 15, id_projet: 2, semaine: '2024-02-19', analyse_design: 2.0, build: 4.0, test: 1.0, total_planifie: 7.0 },
  { id: 16, id_projet: 2, semaine: '2024-02-26', analyse_design: 1.5, build: 4.5, test: 1.5, total_planifie: 7.5 },
  { id: 17, id_projet: 2, semaine: '2024-03-04', analyse_design: 1.0, build: 5.0, test: 2.0, total_planifie: 8.0 },
  { id: 18, id_projet: 2, semaine: '2024-03-11', analyse_design: 0.5, build: 5.0, test: 2.5, total_planifie: 8.0 },
  { id: 19, id_projet: 2, semaine: '2024-03-18', analyse_design: 0.0, build: 4.5, test: 3.0, total_planifie: 7.5 },
  { id: 20, id_projet: 2, semaine: '2024-03-25', analyse_design: 0.0, build: 4.0, test: 3.5, total_planifie: 7.5 },

  // Projet 4: Migration Cloud Infrastructure
  { id: 21, id_projet: 4, semaine: '2024-01-15', analyse_design: 1.5, build: 4.0, test: 0.5, total_planifie: 6.0 },
  { id: 22, id_projet: 4, semaine: '2024-01-22', analyse_design: 1.0, build: 5.0, test: 1.0, total_planifie: 7.0 },
  { id: 23, id_projet: 4, semaine: '2024-01-29', analyse_design: 0.5, build: 5.5, test: 1.5, total_planifie: 7.5 },
  { id: 24, id_projet: 4, semaine: '2024-02-05', analyse_design: 0.0, build: 5.0, test: 2.0, total_planifie: 7.0 },
  { id: 25, id_projet: 4, semaine: '2024-02-12', analyse_design: 0.0, build: 4.5, test: 2.5, total_planifie: 7.0 },
  { id: 26, id_projet: 4, semaine: '2024-02-19', analyse_design: 0.0, build: 4.0, test: 3.0, total_planifie: 7.0 },
  { id: 27, id_projet: 4, semaine: '2024-02-26', analyse_design: 0.0, build: 3.5, test: 3.5, total_planifie: 7.0 },
  { id: 28, id_projet: 4, semaine: '2024-03-04', analyse_design: 0.0, build: 3.0, test: 4.0, total_planifie: 7.0 },
  { id: 29, id_projet: 4, semaine: '2024-03-11', analyse_design: 0.0, build: 2.5, test: 3.5, total_planifie: 6.0 },
  { id: 30, id_projet: 4, semaine: '2024-03-18', analyse_design: 0.0, build: 2.0, test: 3.0, total_planifie: 5.0 }
];

// Données simulées pour les temps consommés
export const mockTempsConsommes = [
  // Projet 1: Refonte Site E-commerce (facturable)
  { id: 1, id_projet: 1, id_personne: 1, semaine: '2024-01-01', jours_consommes: 2.5, facturable: true, commentaire: 'Gestion de projet et coordination équipe', phase: 'analyse_design' },
  { id: 2, id_projet: 1, id_personne: 2, semaine: '2024-01-01', jours_consommes: 3.0, facturable: true, commentaire: 'Développement des composants de base', phase: 'build' },
  { id: 3, id_projet: 1, id_personne: 4, semaine: '2024-01-01', jours_consommes: 2.0, facturable: true, commentaire: 'Création des maquettes et wireframes', phase: 'analyse_design' },

  { id: 4, id_projet: 1, id_personne: 1, semaine: '2024-01-08', jours_consommes: 2.0, facturable: true, commentaire: 'Suivi projet et réunions client', phase: 'analyse_design' },
  { id: 5, id_projet: 1, id_personne: 2, semaine: '2024-01-08', jours_consommes: 4.5, facturable: true, commentaire: 'Implémentation des fonctionnalités principales', phase: 'build' },
  { id: 6, id_projet: 1, id_personne: 3, semaine: '2024-01-08', jours_consommes: 3.5, facturable: true, commentaire: 'Développement backend API', phase: 'build' },
  { id: 7, id_projet: 1, id_personne: 4, semaine: '2024-01-08', jours_consommes: 1.5, facturable: true, commentaire: 'Finalisation des designs', phase: 'analyse_design' },

  { id: 8, id_projet: 1, id_personne: 1, semaine: '2024-01-15', jours_consommes: 2.5, facturable: true, commentaire: 'Coordination équipe et résolution blocages', phase: 'analyse_design' },
  { id: 9, id_projet: 1, id_personne: 2, semaine: '2024-01-15', jours_consommes: 5.0, facturable: true, commentaire: 'Développement frontend avancé', phase: 'build' },
  { id: 10, id_projet: 1, id_personne: 3, semaine: '2024-01-15', jours_consommes: 4.5, facturable: true, commentaire: 'Intégration base de données', phase: 'build' },
  { id: 11, id_projet: 1, id_personne: 5, semaine: '2024-01-15', jours_consommes: 1.0, facturable: true, commentaire: 'Préparation des tests unitaires', phase: 'test' },

  { id: 12, id_projet: 1, id_personne: 1, semaine: '2024-01-22', jours_consommes: 2.0, facturable: true, commentaire: 'Gestion projet et reporting', phase: 'analyse_design' },
  { id: 13, id_projet: 1, id_personne: 2, semaine: '2024-01-22', jours_consommes: 4.5, facturable: true, commentaire: 'Optimisation des performances', phase: 'build' },
  { id: 14, id_projet: 1, id_personne: 3, semaine: '2024-01-22', jours_consommes: 5.0, facturable: true, commentaire: 'Développement des API restantes', phase: 'build' },
  { id: 15, id_projet: 1, id_personne: 5, semaine: '2024-01-22', jours_consommes: 2.0, facturable: true, commentaire: 'Tests d\'intégration', phase: 'test' },

  // Projet 2: Application Mobile CRM (facturable)
  { id: 16, id_projet: 2, id_personne: 1, semaine: '2024-02-05', jours_consommes: 1.5, facturable: true, commentaire: 'Kick-off projet et planification', phase: 'analyse_design' },
  { id: 17, id_projet: 2, id_personne: 7, semaine: '2024-02-05', jours_consommes: 2.0, facturable: true, commentaire: 'Configuration environnement de développement', phase: 'build' },
  { id: 18, id_projet: 2, id_personne: 6, semaine: '2024-02-05', jours_consommes: 3.0, facturable: true, commentaire: 'Analyse des besoins et spécifications', phase: 'analyse_design' },

  { id: 19, id_projet: 2, id_personne: 1, semaine: '2024-02-12', jours_consommes: 2.0, facturable: true, commentaire: 'Suivi projet et coordination', phase: 'analyse_design' },
  { id: 20, id_projet: 2, id_personne: 7, semaine: '2024-02-12', jours_consommes: 3.5, facturable: true, commentaire: 'Développement des écrans principaux', phase: 'build' },
  { id: 21, id_projet: 2, id_personne: 6, semaine: '2024-02-12', jours_consommes: 2.5, facturable: true, commentaire: 'Finalisation des spécifications techniques', phase: 'analyse_design' },

  { id: 22, id_projet: 2, id_personne: 1, semaine: '2024-02-19', jours_consommes: 2.5, facturable: true, commentaire: 'Gestion projet et résolution issues', phase: 'analyse_design' },
  { id: 23, id_projet: 2, id_personne: 7, semaine: '2024-02-19', jours_consommes: 4.0, facturable: true, commentaire: 'Implémentation des fonctionnalités CRM', phase: 'build' },
  { id: 24, id_projet: 2, id_personne: 6, semaine: '2024-02-19', jours_consommes: 1.5, facturable: true, commentaire: 'Validation des spécifications', phase: 'analyse_design' },

  // Projet 3: Système de Gestion Documentaire (non facturable - interne)
  { id: 33, id_projet: 3, id_personne: 2, semaine: '2024-03-01', jours_consommes: 3.0, facturable: false, commentaire: 'Développement module de classification', phase: 'build' },
  { id: 34, id_projet: 3, id_personne: 6, semaine: '2024-03-01', jours_consommes: 2.5, facturable: false, commentaire: 'Analyse des besoins internes', phase: 'analyse_design' },
  { id: 35, id_projet: 3, id_personne: 2, semaine: '2024-03-08', jours_consommes: 4.0, facturable: false, commentaire: 'Intégration système de fichiers', phase: 'build' },

  // Projet 4: Migration Cloud Infrastructure (facturable)
  { id: 25, id_projet: 4, id_personne: 3, semaine: '2024-01-15', jours_consommes: 4.0, facturable: true, commentaire: 'Audit infrastructure existante', phase: 'analyse_design' },
  { id: 26, id_projet: 4, id_personne: 7, semaine: '2024-01-15', jours_consommes: 3.5, facturable: true, commentaire: 'Préparation environnement cloud', phase: 'build' },

  { id: 27, id_projet: 4, id_personne: 3, semaine: '2024-01-22', jours_consommes: 5.0, facturable: true, commentaire: 'Configuration des services AWS', phase: 'build' },
  { id: 28, id_projet: 4, id_personne: 7, semaine: '2024-01-22', jours_consommes: 4.5, facturable: true, commentaire: 'Migration des applications critiques', phase: 'build' },

  { id: 29, id_projet: 4, id_personne: 3, semaine: '2024-01-29', jours_consommes: 4.5, facturable: true, commentaire: 'Tests de performance et optimisation', phase: 'test' },
  { id: 30, id_projet: 4, id_personne: 7, semaine: '2024-01-29', jours_consommes: 5.0, facturable: true, commentaire: 'Migration des bases de données', phase: 'build' },

  { id: 31, id_projet: 4, id_personne: 3, semaine: '2024-02-05', jours_consommes: 4.0, facturable: true, commentaire: 'Monitoring et alertes', phase: 'build' },
  { id: 32, id_projet: 4, id_personne: 7, semaine: '2024-02-05', jours_consommes: 4.5, facturable: true, commentaire: 'Tests de sécurité et compliance', phase: 'test' },

  // Temps non facturable pour formation et administration
  { id: 36, id_projet: 1, id_personne: 2, semaine: '2024-01-29', jours_consommes: 0.5, facturable: false, commentaire: 'Formation nouvelle technologie', phase: 'analyse_design' },
  { id: 37, id_projet: 2, id_personne: 7, semaine: '2024-02-26', jours_consommes: 1.0, facturable: false, commentaire: 'Réunion équipe et retrospective', phase: 'analyse_design' },
  { id: 38, id_projet: 4, id_personne: 3, semaine: '2024-02-12', jours_consommes: 0.5, facturable: false, commentaire: 'Documentation technique interne', phase: 'analyse_design' }
];

// Données pour les statistiques
export const mockStatistiques = {
  generales: {
    nombreProjets: mockProjets.length,
    nombrePersonnes: mockPersonnes.length,
    nombreRattachements: mockRattachements.length,
    totalBudgetJours: mockProjets.reduce((sum, p) => sum + p.budget_jours, 0),
    totalJoursPlanifies: mockTempsPlanifies.reduce((sum, tp) => sum + tp.total_planifie, 0),
    totalJoursConsommes: mockTempsConsommes.reduce((sum, tc) => sum + tc.jours_consommes, 0),
  }
};

// Rôles disponibles
export const ROLES = [
  { value: 'chef_projet', label: 'Chef de Projet' },
  { value: 'developpeur', label: 'Développeur' },
  { value: 'testeur', label: 'Testeur' },
  { value: 'analyste', label: 'Analyste' },
  { value: 'designer', label: 'Designer' }
];

// Statuts de projet
export const STATUTS_PROJET = [
  { value: 'planifie', label: 'Planifié', color: 'bg-blue-100 text-blue-800' },
  { value: 'en_cours', label: 'En Cours', color: 'bg-green-100 text-green-800' },
  { value: 'termine', label: 'Terminé', color: 'bg-gray-100 text-gray-800' },
  { value: 'suspendu', label: 'Suspendu', color: 'bg-red-100 text-red-800' }
];

// Types de facturation
export const TYPES_FACTURATION = [
  { value: true, label: 'Facturable', color: 'bg-green-100 text-green-800' },
  { value: false, label: 'Non facturable', color: 'bg-gray-100 text-gray-800' }
];

// Phases de temps
export const CATEGORIES_TEMPS = [
  { value: 'analyse_design', label: 'Analyse & Design', color: 'bg-blue-100 text-blue-800' },
  { value: 'build', label: 'Développement', color: 'bg-green-100 text-green-800' },
  { value: 'test', label: 'Tests', color: 'bg-orange-100 text-orange-800' }
];

// Alias pour les phases (garde la même constante pour la compatibilité)
export const PHASES_TEMPS = CATEGORIES_TEMPS;

// Fonctions utilitaires pour les données simulées
export const getMockProjetById = (id) => {
  return mockProjets.find(p => p.id === parseInt(id));
};

export const getMockPersonneById = (id) => {
  return mockPersonnes.find(p => p.id === parseInt(id));
};

export const getMockRattachementsByProjet = (projetId) => {
  return mockRattachements.filter(r => r.id_projet === parseInt(projetId));
};

export const getMockTempsPlanifiesByProjet = (projetId) => {
  return mockTempsPlanifies.filter(tp => tp.id_projet === parseInt(projetId));
};

export const getMockTempsConsommesByProjet = (projetId) => {
  return mockTempsConsommes.filter(tc => tc.id_projet === parseInt(projetId));
};

export const getMockTempsConsommesByPersonne = (personneId) => {
  return mockTempsConsommes.filter(tc => tc.id_personne === parseInt(personneId));
};

export const getMockProjectStats = (projetId) => {
  const projet = getMockProjetById(projetId);
  if (!projet) return null;

  const rattachements = getMockRattachementsByProjet(projetId);
  const tempsPlanifies = getMockTempsPlanifiesByProjet(projetId);
  const tempsConsommes = getMockTempsConsommesByProjet(projetId);

  const totalPlanifie = tempsPlanifies.reduce((sum, tp) => sum + tp.total_planifie, 0);
  const totalConsomme = tempsConsommes.reduce((sum, tc) => sum + tc.jours_consommes, 0);

  return {
    ...projet,
    nombrePersonnes: rattachements.length,
    totalJoursPlanifies: totalPlanifie,
    totalJoursConsommes: totalConsomme,
    pourcentageConsommation: totalPlanifie > 0 ? (totalConsomme / totalPlanifie) * 100 : 0,
    pourcentageConsommationBudget: projet.budget_jours > 0 ? (totalConsomme / projet.budget_jours) * 100 : 0,
    joursRestants: projet.budget_jours - totalConsomme
  };
};

// Services simulés (fallback quand l'API n'est pas disponible)
export const mockServices = {
  projets: {
    getAll: () => Promise.resolve(mockProjets),
    getById: (id) => Promise.resolve(getMockProjetById(id)),
    create: (projet) => Promise.resolve({ ...projet, id: Date.now() }),
    update: (id, projet) => Promise.resolve({ ...projet, id }),
    delete: (id) => Promise.resolve(),
    getStats: (id) => Promise.resolve(getMockProjectStats(id)),
  },
  
  personnes: {
    getAll: () => Promise.resolve(mockPersonnes),
    getById: (id) => Promise.resolve(getMockPersonneById(id)),
    create: (personne) => Promise.resolve({ ...personne, id: Date.now() }),
    update: (id, personne) => Promise.resolve({ ...personne, id }),
    delete: (id) => Promise.resolve(),
  },
  
  rattachements: {
    getAll: () => Promise.resolve(mockRattachements),
    getByProjet: (projetId) => Promise.resolve(getMockRattachementsByProjet(projetId)),
    create: (rattachement) => Promise.resolve({ ...rattachement, id: Date.now() }),
    delete: (id) => Promise.resolve(),
  },
  
  tempsPlanifies: {
    getByProjet: (projetId) => Promise.resolve(getMockTempsPlanifiesByProjet(projetId)),
    upsert: (projetId, semaine, temps) => Promise.resolve({ id: Date.now(), id_projet: projetId, semaine, ...temps }),
    delete: (id) => Promise.resolve(),
  },
  
  tempsConsommes: {
    getByProjet: (projetId) => Promise.resolve(getMockTempsConsommesByProjet(projetId)),
    getByPersonne: (personneId) => Promise.resolve(getMockTempsConsommesByPersonne(personneId)),
    upsert: (projetId, personneId, semaine, joursConsommes, facturable, commentaire, phase) => Promise.resolve({
      id: Date.now(),
      id_projet: projetId,
      id_personne: personneId,
      semaine,
      jours_consommes: joursConsommes,
      facturable: facturable !== undefined ? facturable : true,
      commentaire,
      phase: phase || 'build'
    }),
    delete: (id) => Promise.resolve(),
  },
  
  statistiques: {
    getGenerales: () => Promise.resolve(mockStatistiques.generales),
    getParProjet: (projetId) => Promise.resolve(getMockProjectStats(projetId)),
    getParPersonne: (personneId) => Promise.resolve({}),
  }
};

export default {
  mockProjets,
  mockPersonnes,
  mockRattachements,
  mockTempsPlanifies,
  mockTempsConsommes,
  mockStatistiques,
  ROLES,
  STATUTS_PROJET,
  getMockProjetById,
  getMockPersonneById,
  getMockRattachementsByProjet,
  getMockTempsPlanifiesByProjet,
  getMockTempsConsommesByProjet,
  getMockTempsConsommesByPersonne,
  getMockProjectStats,
  mockServices
}; 